<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import simplebar from "simplebar-vue";
import API from "@/router/layouts/API";
import CopyableText from "@/components/CopyableText";

export default {
  page: {
    title: "Convert API",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    simplebar,
    API,
    CopyableText
  },
  data() {
    return {

    };
  },
  validations: {

  },
  methods: {
    goto(refName) {
      let element = this.$refs[refName];
      element.scrollIntoView({ block: 'end', behavior: 'smooth' });
      this.$nextTick(() => {
        //document.scrollingElement.scrollTop -= 1;
      });
    },
  }
};
</script>

<template>
  <API>
    <!-- LINKS -->
    <template v-slot:contents>
      <ul class="c-menu">
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('introduction')"
          >
            Introduction
          </a>
        </li>
        <li>
          <a
              class="font-size-16"
              href="javascript:void(0);"
              v-on:click="goto('api')"
          >
            API
          </a>
        </li>
      </ul>
    </template >
    <!-- CONTENT -->
    <template v-slot:content>
      <!-- Introduction -->
      <div class="c-api-section" ref="introduction">
        <h1 class="pb-0">
          Introduction
        </h1>
        <hr>
        <div class="c-api-content">
          In an order to ease public integration, we provide a public convert API used to convert BattlEye GUIDs to SteamID64 format.<br>
          <br>
          <b>All data retrieved through this API is not to be used for any commercial purposes or services facilitating commercial purposes.</b>
        </div>
      </div>
      <!-- Server Id -->
      <div class="c-api-section" ref="api">
        <h1 class="pb-0">
          API
        </h1>
        <hr>
        <div class="c-api-content">
          The base address for the Geo API is <CopyableText class="text-code text-primary" text="http://convert-api.cftools.cloud/"/>.<br>
          <br>
          This API is only served via HTTP and not HTTPS.<br>
          <hr class="small">
          <h3><span class="text-code text-warning">[GET]</span> <CopyableText class="text-code" text="/v1/{identifier}" /></h3>
          Request information about an identifier address.
          <hr class="small">
          Response example:
<pre class="text-code">
{
  "status": true,
  "results": [
    {
      "request": {
        "identifier": "ce8c653f52f56fb1ea61288fbd87f14c",
        "type": "IdentityType.BATTLEYE_GUID",
        "delta": 1.1409
      },
      "status": true,
      "data": {
        "steam64": "76561198410213019",
        "battleye_guid": "ce8c653f52f56fb1ea61288fbd87f14c",
        "bi_uid": "M7FId1aynmPEPHwPiwHQg4mgZ1v5Gj0WAe5zTyihU-4="
      }
    }
  ]
}
</pre>
        </div>
      </div>
    </template>
  </API>
</template>